var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 93,
    viewBox: "0 0 91 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0308 82.7991H7.87273L0.0523912 38.0759C-0.315785 35.9759 1.30351 34.0498 3.43416 34.0498H75.0274V82.7991H75.0308Z",
    fill: "#8EEDEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6898 26.2359H55.5994C55.5994 26.2359 50.145 25.4927 46.7359 31.8165L42.3042 38.8868H22.5318C22.5318 38.8868 18.4409 38.1437 17.0773 42.9811C15.7137 47.8185 8.55469 82.7987 8.55469 82.7987H80.4854L89.6898 26.2359Z",
    fill: "#F3FCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5062 1.22725L33.2188 12.593C31.7768 14.5702 33.1881 17.3452 35.6358 17.3452H52.2106C54.6583 17.3452 56.0696 14.5668 54.6276 12.593L46.3402 1.22725C45.1436 -0.409085 42.6993 -0.409085 41.5062 1.22725Z",
    fill: "#43BFBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9232 27.5722C41.4278 27.5722 39.4062 25.5506 39.4062 23.0552V16.4076C39.4062 13.9122 41.4278 11.8906 43.9232 11.8906C46.4186 11.8906 48.4402 13.9122 48.4402 16.4076V23.0552C48.4402 25.5506 46.4186 27.5722 43.9232 27.5722Z",
    fill: "#43BFBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2578 82.7679H80.5593L89.3478 28.7516C89.566 27.4153 88.533 26.2051 87.1796 26.2051H55.6699",
    stroke: "#0E7F7F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3791 38.856H22.6067C22.6067 38.856 18.4408 38.8219 17.1522 42.9502C16.2727 45.7729 13.4773 59.0545 11.3262 69.5135",
    stroke: "#0E7F7F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7656 79.8809H76.9471L78.4471 70.7788H55.2656L53.7656 79.8809Z",
    fill: "#BEFCEC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.3642,
    cy: 89.1462,
    rx: 43.6357,
    ry: 2.89768,
    fill: "#9FC1C1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.83538,
    y1: 82.1977,
    x2: 1.19771,
    y2: 46.1646,
    stroke: "#0E7F7F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadEmployees);
export default __webpack_public_path__ + "static/media/Upload_employees.3baf7792773e7605ea665ce489c8afd2.svg";
export { ForwardRef as ReactComponent };